import {FormGroup} from "@angular/forms";
import {ProductCollectionsEnum} from "../../shared/enums/product-collections.enum";
import {ObservableBaseForm} from "../../shared/forms/observable-base.form";
import {EmptySearchParamsFilterModel} from "../../shared/models/search/params/filters/empty-search-params-filter.model";
import {CollectionSearchParamsFactoryService} from "../services/factories/collection-search-params-factory.service";

export abstract class CollectionFilterBaseForm<TFilterParams extends EmptySearchParamsFilterModel> extends ObservableBaseForm<TFilterParams> {

    public abstract collection: ProductCollectionsEnum;

    protected constructor(
        formInstance: FormGroup,
        initialValues: TFilterParams,
        protected searchParamsFactory: CollectionSearchParamsFactoryService
    ) {
        super(formInstance, initialValues);
    }

    public reset(): void {
        this.formInstance.patchValue(this.searchParamsFactory.createFilter(this.collection), {emitEvent: false});
    }
}
